<template>
  <cs-form-dialog
    id="group-publish-dialog"
    v-model="popupDialog"
    heading="Apply and Distribute Update"
    :primary-action="{ label: 'Confirm', eventName: 'dlg-publish' }"
    :secondary-action1="{ label: 'Cancel', eventName: 'dlg-cancel' }"
    @primary-click="publish"
    @secondary1-click="popupDialog = false"
  >
    <template #cs-form-dialog-content>
      <v-container>
        <v-radio-group v-model="selected" class="group-publish-dialog-radio-group">
          <v-radio
            :value="PUBLISH_OPTIONS.PARENT_SITE_ONLY"
            class="group-publish-dialog-radio-group-item"
          >
            <template #label>
              <div>
                <div class="text-title">Update parent site only</div>
                <div class="text-caption">
                  Applies the update to the parent site only. It will not be pushed to any child
                  sites.
                </div>
              </div>
            </template>
          </v-radio>

          <v-radio
            :value="PUBLISH_OPTIONS.PARENT_SITE_AND_CHILD_SITES"
            class="group-publish-dialog-radio-group-item"
          >
            <template #label>
              <div>
                <div class="text-title">Update parent site and push to child sites</div>
                <div class="text-caption">
                  Applies the update to the parent site and sends it to child sites. Child site
                  administrators will need to accept the update before it goes live.
                </div>
              </div>
            </template>
          </v-radio>

          <v-radio :value="PUBLISH_OPTIONS.ALL_SITES" class="group-publish-dialog-radio-group-item">
            <template #label>
              <div>
                <div class="text-title">Update all sites automatically</div>
                <div class="text-caption">
                  Applies the update to the parents and all child sites at the same time. This
                  ensures parent and child sites have the same content version. No further action is
                  required by child site administrators.
                </div>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-container>
    </template>
  </cs-form-dialog>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import { PUBLISH_OPTIONS } from '@/constants';

export default {
  name: 'GroupPublishDialog',
  extends: CSBase,
  props: {
    modelValue: { type: Boolean, required: true }
  },
  emits: ['update:modelValue', 'publish'],
  data() {
    return {
      selected: PUBLISH_OPTIONS.PARENT_SITE_ONLY,
      PUBLISH_OPTIONS
    };
  },
  computed: {
    popupDialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    }
  },
  watch: {
    modelValue(value) {
      if (value) {
        this.selected = PUBLISH_OPTIONS.PARENT_SITE_ONLY;
      }
    }
  },

  methods: {
    publish() {
      this.$emit('publish', this.selected);
      this.popupDialog = false;
    }
  }
};
</script>

<style scoped>
.group-publish-dialog-radio-group-item {
  padding-bottom: 16px;
}
</style>
